import { NotificationGroup, NotificationType } from './types';

export function groupNotifications(notifications: NotificationType[]) {
  const groups: NotificationGroup[] = [];
  if (notifications.length === 0) return groups;

  let currentGroup: NotificationGroup = {
    id: notifications[0].id,
    items: [notifications[0]],
    type: `${notifications[0].event?.eventData?.model}-${notifications[0].event?.eventData?.operation}`,
  };

  for (let i = 1; i < notifications.length; i++) {
    const n = notifications[i];
    const currentGroupType = `${n.event?.eventData?.model}-${n.event?.eventData?.operation}`;

    if (currentGroupType === currentGroup.type) {
      currentGroup.items.push(n);
    } else {
      groups.push(currentGroup);
      currentGroup = {
        id: n.id,
        items: [n],
        type: currentGroupType,
      };
    }
  }
  groups.push(currentGroup);
  return groups;
}

export function paginationUpdater({
  data,
  prepend,
  replace,
  state,
}: {
  data: NotificationGroup[];
  prepend?: boolean;
  replace?: boolean;
  state: NotificationGroup[] | undefined;
}) {
  if (replace) {
    return data;
  }

  if (!state || state.length === 0) {
    return data;
  }

  if (prepend) {
    const result = [...data];

    if (data.length > 0 && state.length > 0) {
      const lastNewGroup = data[data.length - 1];
      const firstExistingGroup = state[0];

      if (lastNewGroup.type === firstExistingGroup.type) {
        const mergedGroup: NotificationGroup = {
          id: lastNewGroup.id,
          items: [...lastNewGroup.items, ...firstExistingGroup.items],
          type: lastNewGroup.type,
        };

        result[result.length - 1] = mergedGroup;
        return [...result, ...state.slice(1)];
      }
    }

    return [...result, ...state];
  }

  const result = [...state];

  if (state.length > 0 && data.length > 0) {
    const lastExistingGroup = state[state.length - 1];
    const firstNewGroup = data[0];

    if (lastExistingGroup.type === firstNewGroup.type) {
      const mergedGroup: NotificationGroup = {
        id: lastExistingGroup.id,
        items: [...lastExistingGroup.items, ...firstNewGroup.items],
        type: lastExistingGroup.type,
      };

      result[result.length - 1] = mergedGroup;
      return [...result, ...data.slice(1)];
    }
  }

  return [...result, ...data];
}

export function readUpdater({
  notificationIds,
  state,
}: {
  notificationIds: string[];
  state: NotificationGroup[] | undefined;
}) {
  return state?.map((group) => {
    const items = group.items || [];
    const updatedItems = items.map((item) => {
      if (notificationIds.includes(item.id)) {
        return { ...item, readAt: new Date() };
      }
      return item;
    });
    return { ...group, items: updatedItems };
  });
}

export function getNotificationVisualKey(notification: NotificationType): string {
  const eventData = notification.event?.eventData as any;
  if (!eventData) return notification.id;

  const result = eventData.result ?? {};

  const parts = [
    eventData.model,
    eventData.operation,
    notification.from?.id,
    result.talentProfile?.id,
    result.jobAd?.id,
    result.company?.id,
    result.publisherCompany?.id,
    result.clientCompany?.id,
    result.user?.id,
    result.invitedBy?.id,
    result.jobDescription?.title,
    result.stepName,
    result.role?.role,
    result.verificationStatus,
    result.employmentType,
    result.displayName,
    result.email,
    result.name,
    result.title,
  ];

  const key = parts.filter((p) => p != null).join('-');
  return key || notification.id;
}
